import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const RelationalAlgebraQueryProcessing = () => (
  <QPhototModuleSubtopic
    title="Relational Algebra - Translating SQL Queries into Relational Algebra – Query Processing"
    videos={[
      "https://www.youtube.com/embed/4YilEjkNPrQ",
      "https://www.youtube.com/embed/Dgq01JAWw4Y",
      "https://www.youtube.com/embed/4y4tBfnPlS8",
      "https://www.youtube.com/embed/5KlHir314FQ",
      "https://www.youtube.com/embed/lJvkIgFT3dY",
      "https://www.youtube.com/embed/rKN60UnVsMw"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "1) Consider the following tables.\nOrders(OrderID, CustomerID),\nProducts(ProductID, ProductName),\nOrdersDetails(OrderID, ProductID, UnitPrice, Quantity)\nWrite a SQL to find out the customer id of any customer who has ordered the product \"Queso Cabrales\" with quantity >6. Transform the SQL into a collection of relational algebra which denotes different execution plans of the SQL. Also, visualize the answer with the help of the Query tree."
      },
      {
        text: "2) Consider the following schema:\nSuppliers(sid: integer, sname: string, address: string)\nParts(pid: integer, pname: string, color: string)\nCatalog(sid: integer, pid: integer, cost: real)\nThe key fields are underlined, and the domain of each field is listed after the fieldname. The Catalog relation lists the prices charged for parts by Suppliers.\nWrite the following queries in relational algebra.\na) Find the names of suppliers who supply some red part.\nb) Find the sids of suppliers who supply some red or green part.\nc) Find the Sids of suppliers who supply some red part or residing at Ashok Nagar.\nd) Find the sids of suppliers who supply some red part and some green part.\ne) Find the sids of suppliers who supply every part."
      },
      {
        text: "3) Considering the following Library Relational Schema. Write the queries in relational algebra format.",
        image:"/dbms_22.png"
      },
      {
        text: "4) Derive equivalent relational Algebra expression/SQL for the following",
        image:"/dbms_23.png"
      },
      {
        text: "5) Consider the following relations containing airline flight information:\nFlights(flno, from, to, distance, departs, arrives, aid)\nAircraft(aid, aname, total_capacity)\nCertified(eid, aid)\nEmployees(eid, ename, salary)\nConsider the above schema and write the following query into relational algebra.\nThe key attributes are flno, aid, eid.\n(i) List the names of pilots certified for some Boeing aircraft.\n(ii) List the flight number that can be piloted by every pilot whose salary is more than Rs.150,000\n(iii) Find the total amount paid as salaries to Boeing certified pilot\n(iv) Find the names of pilots who can operate planes with a range greater than 1500 miles but are not certified on any Boeing aircraft.\n(v) Find the aids of all aircraft that can be used on non-stop flights from Chennai to Delhi"
      },
      {
        text: "6) Consider the following Publication Database\nAuthor (author_id, first_name, last_name)\nAuthor_Publication (author_id, pub_id, author_pos)\nBook (book_id, book_title, month, year, editor)\nPublication (pub_id, title, book_id)",
        image:"/dbms_24.png"
      }
    ]}
    exampleVideos={[]}
  />
);

export default RelationalAlgebraQueryProcessing;
